/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Stránka nebyla nalezena",
  "ComingSoon": "Již brzy",
  "YesanPersonalFinance": "Yesan, Osobní finance",
  "Yesan": "Yesan",
  "PersonalFinance": "Osobní finance",
  "YesanDownload": "Yesan ke stažení",
  "ThisWebsiteUsesCookies": "Soubory cookie používáme ke shromažďování a analýze informací o výkonu a používání našich stránek a k poskytování funkcí sociálních médií. Pokračováním souhlasíte s našimi",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Staňte se finančně svobodnými",
  "inStepsAndActions": "V 8 krocích a 3 akcích.",
  "TrackPlanAnalyze": "Sledujte. Plánujte. Analyzujte.",
  "FTrack": "1. Sledování",
  "FPlan": "2. Plánování",
  "FAnalyze": "3. Analyzujte",
  "Features": "Funkce",
  "FeaturesSubHeading": "Čistý začátečník, který je již finančně gramotný, toto je aplikace, kterou potřebujete, abyste se stali finančně svobodnými.",
  "ManageAccounts": "Správa účtů",
  "CashLiquidFixedAssetsLiabilities": "Peněžní prostředky, likvidní prostředky, dlouhodobý majetek a závazky.",
  "TrackTransactions": "Sledujte transakce",
  "IncomesExpensesTransferInvestments": "Příjmy, výdaje, převody, investice.",
  "ImportExport": "Import / export",
  "YourDataAlwaysAccessible": "Vaše data vždy přístupná.",
  "PlanYourFreedom": "Plánujte svou svobodu",
  "StepsAwayFromFI": "8 kroků od finanční nezávislosti.",
  "BudgetsAndGoals": "Rozpočty a cíle",
  "CheckYourProgressAndAchieve": "Kontrolujte svůj pokrok a dosahujte svých finančních cílů.",
  "DashboardAndAnalytics": "Dashboard a analytika",
  "ReviewLearnOptimizeWith": "Prohlížejte, učte se, optimalizujte pomocí grafů, přehledů a nástrojů.",
  "Security": "Zabezpečení",
  "MilitaryGradeEncryption": "Šifrování vojenského stupně, podpora biometrie, data uložená ve vašich zařízeních.",
  "OfflineMode": "Offline režim",
  "YourDataAlwaysAccessibleAndModif": "Vaše data vždy přístupná a upravitelná.",
  "Track": "Sledování",
  "Income": "Příjmy",
  "Expense": "Výdaje",
  "Transfer": "Převod",
  "transactionsAndManageAccounts": "transakce a spravovat různé účty:",
  "checkings": ".",
  "savings": "Spořicí účty",
  "realEstate": "Nemovitosti",
  "stocks": "Akciové trhy",
  "bonds": "Dluhopisy",
  "crypto": "Kryptoměny",
  "notes": "Bankovky, peněženka",
  "envelopes": "Obálky",
  "privateEquity": "Soukromý kapitál",
  "metal": "Kov",
  "retirement": "Důchod",
  "lifeInsurance": "Životní pojištění",
  "intellectualProperty": "Duševní vlastnictví",
  "otherLiquidAsset": "Ostatní likvidní aktiva",
  "otherFixedAsset": "Ostatní dlouhodobý majetek",
  "mortgage": "Hypotéka",
  "loan": "Spotřebitelský úvěr",
  "creditCard": "Kreditní karta",
  "otherLiability": "Ostatní pasiva",
  "AccountsManagement": "Správa účtů",
  "MultipleAccountsTypesAndGrouping": "Více typů účtů a jejich seskupování",
  "LinkAccounts": "Propojení účtů z vašich institucí (dostupné pouze v některých zemích)",
  "SmartAccounts": "Inteligentní účty",
  "AddEditDeleteTransactions": "Přidávání / úpravy / mazání transakcí",
  "TickVerifiedTransactions": "Zaškrtávání ověřených transakcí",
  "CategorizeTransactions": "Kategorizace transakcí",
  "TagTransactions": "Označovat transakce",
  "TrackKakeiboType": "Sledovat typ Kakeibo",
  "TrackInvestments": "Sledovat investice (dostupné pouze v některých zemích)",
  "ImportFromCSVFile": "Importovat celé nebo postupně transakce ze souboru CSV",
  "ExportToCSVFile": "Exportovat transakce do souboru CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "Plán 8 kroků k finanční nezávislosti, podrobné sestavování rozpočtu, rychlejší dosažení finančních cílů.",
  "levelsTowardsFI": "8 stupňů k finanční nezávislosti",
  "EstablishBudgetsPer": "Stanovení rozpočtů na",
  "account": "účet",
  "accountType": "typ účtu",
  "KakeiboType": "Kakeibo typ účtu",
  "category": "kategorie",
  "tag": "značka",
  "label": "štítek",
  "TrackBudgetsPerFrequency": "Sledování rozpočtů podle frekvence",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Vytvářejte cíle týkající se výdajů, zůstatku, peněžních toků, akcí",
  "TrackGoalsProgress": "Sledování pokroku v plnění cílů",
  "ReviewLearnOptimizeWithReportsCharts": "Přehled, učení, optimalizace pomocí přehledů, grafů, trendů, přehledů a nástrojů.",
  "Dashboard": "Dashboard",
  "FSNetWorth": "Finanční výkazy: Čistý majetek",
  "FSPnL": "Finanční výkazy: Výkaz zisků a ztrát",
  "FSBalanceSheetAssetsLiabilities": "Finanční výkazy: Rozvaha, aktiva, pasiva",
  "FSCashFlow": "Finanční výkazy: Výkaz peněžních toků, debet, kredit, toky",
  "FSFlows": "Účetní výkazy: Toky:",
  "FSRatios": "Finanční výkazy: Poměrové ukazatele:",
  "TrendsMonthEnd": "Trendy ke konci měsíce: Příjmy a výdaje, peněžní toky",
  "TrendsPerformance": "Trendy výkonnosti: Meziroční, meziměsíční, WoW",
  "IncomeTrendsPer": "Trendy příjmů za",
  "SpendingTrendsPer": "Trendy výdajů na",
  "RecurringItemsIE": "Opakující se položky: Příjmy a výdaje",
  "DebtProgressTrends": "Trendy vývoje dluhu",
  "KakeiboMTDReviewTrends": "Kakeibo: Přehled MTD, poslední měsíc, trendy",
  "FIWCLE": "Finanční nezávislost: Nástěnný graf, výdaje podle životních energií",
  "DebtPaydownSnowballAvalanche": "Splácení dluhů: Dluh: Sněhová koule, lavina",
  "FullyCustomizableAnalyticsRange": "Plně přizpůsobitelný časový rozsah analýzy",
  "ContactUs": "Kontaktujte nás",
  "Privacy": "Ochrana osobních údajů",
  "Terms": "Podmínky",
  "About": "O webu",
  "IAgreeToThe": "Souhlasím s",
  "AndThe": "a",
  "PrivacyPolicy": "Zásadami ochrany osobních údajů",
  "TermsOfUse": "Podmínky používání",

  "DigitalSoftwareExperienceTagline": "Digitální software pro moderní svět",
  "DigitalExperience": "Digitální zkušenosti",
  "SoftwareForTheModernWorld": "Software pro moderní svět",
  "MobileApplications": "Mobilní aplikace",
  "forConnectedAndOfflineHumans": "pro připojené a offline lidi",
  "CloudSaaS": "Cloud SaaS",
  "ResponsiveAndWebServices": "Responzivní a webové služby",
  "PersonalFinanceServices": "Služby v oblasti osobních financí",
  "YS_p1": "Yesan je dynamická softwarová společnost, která se specializuje na vývoj špičkových mobilních aplikací na míru spotřebitelům. Díky hlubokému porozumění vyvíjejícím se potřebám a preferencím dnešních technicky zdatných uživatelů se společnost Yesan věnuje vytváření intuitivních, poutavých a funkčně bohatých mobilních aplikací, které obohacují život uživatelů.",
  "YS_p2": "Jádrem poslání společnosti Yesan je neúnavné úsilí o inovace a kreativitu, každý produkt je pečlivě vytvořen tak, aby poskytoval bezproblémovou funkčnost a výjimečný uživatelský zážitek.",
  "PersonalFinanceApplication": "Aplikace pro osobní finance",
  "YPF_p1": "Yesan, osobní finance je špičková mobilní aplikace pro osobní finance, která byla navržena tak, aby uživatelům poskytla komplexní nástroje pro správu financí, které budou mít pohodlně dostupné na dosah ruky. Díky elegantnímu a intuitivnímu rozhraní nabízí aplikace Yesan, osobní finance komplexní přístup ke správě financí a vychází vstříc uživatelům všech úrovní finanční gramotnosti.",
  "YPF_p2": "Mezi klíčové funkce patří sledování rozpočtu, kategorizace výdajů a sledování transakcí v reálném čase, což uživatelům umožňuje bez námahy získat přehled o svých výdajových návycích. Aplikace také nabízí přizpůsobitelné možnosti sestavování rozpočtu, což uživatelům umožňuje nastavit si finanční cíle a sledovat jejich průběh.",
  "YPF_p3": "Yesan, Personal Finance navíc upřednostňuje bezpečnost a využívá nejmodernější šifrovací protokoly k ochraně citlivých finančních informací uživatelů. Díky bezpečnostním opatřením na úrovni bank mohou uživatelé bez obav propojovat své účty a synchronizovat transakce, aniž by bylo ohroženo jejich soukromí.",
  "YPF_p4": "Yesan, Personal Finance jde nad rámec základního rozpočtování a nabízí pronikavou analýzu a personalizovaná doporučení pro optimalizaci finančních rozhodnutí. Ať už jde o identifikaci potenciálních možností úspor, sledování investičních portfolií nebo správu strategií splácení dluhů, aplikace poskytuje uživatelům na míru šité poznatky, které jim pomohou dosáhnout jejich finančních cílů.",
  "Discover": "Objevte",
  "Firstname": "Jméno",
  "Lastname": "Příjmení",
  "Company":"Společnost",
  "Subject": "Předmět",
  "Email": "E-mail",
  "Message": "Zpráva",
  "ThankYouForContactingUs": "Děkujeme, že jste nás kontaktovali",
  "ValidFirstnameRequired": "Je vyžadováno platné křestní jméno.",
  "ValidLastnameRequired": "Je vyžadováno platné příjmení.",
  "ValidEmailAddressRequired": "Zadejte prosím platnou e-mailovou adresu.",
  "ValidSubjectRequired": "Vyberte prosím platný předmět.",
  "ValidMessageRequired": "Zadejte prosím platnou zprávu.",
  "UnableToSendTheFormPleaseRetryLater": "Formulář se nepodařilo odeslat, zkuste to prosím později.",
  "Information": "Informace",
  "Sales":"Prodej",
  "Support": "Podpora",
  "Press": "Tisk",
  "Partnership": "Partnerství",
  "Other": "Další",
  "Blog":"Blog",

  "Accept":"Přijmout",
  "Decline":"Odmítnout",

  "WorklogCalendar":"Worklog Kalendář pro Jiru",

  "DirectlyAccessibleInProjectApps":"Přímo přístupné v projektových aplikacích",
  "VisualizeWhereYouSpentYourTime":"Vizualizujte, kde jste strávili svůj čas",
  "AllYourWorklogsInACalendar":"Všechny vaše pracovní záznamy v kalendáři",
  "MonthSummary":"Měsíční přehled",
  "CheckIfYouForgotToLogTime":"Zkontrolujte, zda jste nezapomněli zaznamenat čas.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Přímý přístup k problémům a aktualizace času",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Kliknutím na položku pracovního záznamu získáte přímý přístup k problémům a můžete upravovat sledovaný čas.",
  "AlsoAvailableInDarkMode":"K dispozici také v tmavém režimu",
  "DirectlyLogWorkOnTheCalendarVisually":"Vizuálně zaznamenávejte práci přímo do kalendáře",
  "ClickOnTheCalendarToCreateNewWorklog":"Kliknutím na kalendář vytvoříte nový pracovní záznam",

  "AppsForAtlassian":"Aplikace pro Atlassian",
  "YCL_p1":"Vizualizujte všechny své worklogy v kalendáři se zobrazením měsíce, týdne, pracovního týdne a dne.",
  "YCL_p2":"Zaznamenávejte práci přímo z kalendáře vizuálním výběrem časového úseku.",
  "YCL_p3":"Zjistěte, zda jste nezapomněli sledovat čas pro své pracovní výkazy.",
  "YCL_p4":"K dispozici ve vašem jazyce: angličtina (Velká Británie), angličtina (USA), čínština (zjednodušená), čínština (tradiční), čeština, dánština, estonština, finština, francouzština, islandština, italština, japonština, korejština, němčina, nizozemština, norština, polština, portugalština (Brazílie), portugalština (Portugalsko), ruština, španělština, švédština, turečtina.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Finanční portfolio pro Jira",
  "BringRealFinancialPortfolio":"Zaveďte do Jiry skutečné řízení finančního portfolia. Sledujte rozpočty, investice (CapEx) a provozní náklady (OpEx) i náklady na projekty na jednom místě.",
  "YFPAboutQ":"Kolik nás naše projekty v Jira skutečně stojí?",
  "YFPAbout":"Finanční portfolio pro Jira\nFinanční vedoucí a PMO se snaží odpovědět na jednoduchou otázku:\nKolik nás naše projekty v Jira skutečně stojí?\nJira sleduje práci.\nFinanční oddělení sleduje rozpočty.\nTato aplikace konečně spojuje obojí.\n\nFinanční portfolio promění Jira v odlehčenou platformu pro PPM + finanční plánování — bez nutnosti drahých podnikových nástrojů.",
  "YFPPorfolioQ":"Rozpočty a sledování portfolia",
  "YFPPorfolioP":"Vytvářejte portfolia napříč více projekty Jira a definujte: výši rozpočtu, měnu, časové období, zahrnuté projekty, týmy. Sledujte skutečné náklady automaticky, jakmile se práce v Jira uskuteční.",
  "YFPPorfolioListQ":"Portfolia",
  "YFPPorfolioListP":"Vytvářejte finanční portfolia, která kombinují více projektů Jira, a okamžitě vidíte: rozpočet vs. skutečné náklady, míru čerpání projektu v reálném čase, rozpis CapEx vs. OpEx, náklady na jeden úkol a projekt, exportovatelné finanční zprávy. Vše přímo na základě pracovních záznamů Jira.",
  "CostQ":"Automatický výpočet nákladů",
  "CostP":"Proměňte sledování času na skutečná finanční data. Aplikace: Čte pracovní záznamy Jira, aplikuje hodinové sazby, denně vypočítává skutečné náklady projektu. Žádné tabulky. Žádná manuální práce.",
  "RatesQ":"Sazby",
  "RatesP":"Nastavte hodinovou sazbu pro projekt, tým nebo globálně",
  "ReportQ":"Finanční reporty ve formátu CSV",
  "ReportP":"Exportujte finanční data portfolia během několika sekund. Ideální pro: Finanční týmy, reporting pro CFO, plánování rozpočtu, podporu auditu",
  "SettingsQ": "Klasifikace CapEx vs. OpEx",
  "SettingsP": "Podpora účetních a auditorských požadavků. Klasifikujte práci na: Kapitalizovatelný vývoj (CapEx), provozní práce (OpEx). Generujte exportovatelné reporty připravené pro finanční týmy."
};

export const documents = {
};
